export default function modifierSettings() {
  return [
    {
      name: 'preventOverflow',
      enabled: true,
      options: {
        altAxis: true,
        padding: 8,
      },
    },
    // Supports re-positioning the popper when close to screen edges.
    {
      name: 'flip',
      enabled: true,
      options: {
        fallbackPlacements: ['top', 'bottom', 'left', 'right'],
      },
    },
    // Forces centering for top and bottom positioning.
    {
      name: 'computeStyles',
      enabled: true,
      options: {
        adaptive: false,
      },
    },
    // Offsets the position of the tooltip for some breathing room.
    {
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, 12],
      },
    },
  ];
}
